import _Inputmask from 'inputmask'

// Vite ESM/CJS interop: the UMD bundle exposes the constructor under .default
// Fall back to the import itself for environments where interop unwraps it automatically
const Inputmask: typeof _Inputmask = (_Inputmask as any).default ?? _Inputmask

export function applyMask(element: HTMLInputElement, mask: string): void {
  if (mask === 'cpf-cnpj') {
    Inputmask({
      mask: ['999.999.999-99', '99.999.999/9999-99'],
      keepStatic: true,
    }).mask(element)
    return
  }
  Inputmask({ mask }).mask(element)
}

export function removeMask(element: HTMLInputElement): void {
  Inputmask.remove(element)
}

export function applyCurrencyMask(element: HTMLInputElement): void {
  Inputmask({
    mask: ['R$ 9,99', 'R$ 99,99', 'R$ 999,99', 'R$ 9.999,99', 'R$ 99.999,99'],
    greedy: false,
    placeholder: '0',
  }).mask(element)
}
